export const addValidationErrorElement = (msg, id) => {
  //e.g firstName_validation_error
  const fieldError = id + "_validation_error"

  //we don't need to make it twice
  if (document.getElementById(fieldError)) {
    return;
  }

  //use id and grab element
  let elem  = document.getElementById(id)

  if (!elem) {
    return;
  }

  //create div
  let div = document.createElement("div")

  // add id attribute with a name of fieldError (e.g firstName_validation_error)
  div.setAttribute("id", fieldError)

  // adds text/error message onto the div attribute
  div.appendChild(document.createTextNode(msg))
  elem.parentNode.append(div)
  elem.classList.add("validation_error")
  elem.classList.remove("valid")
}

export const removeValidationErrorElement = (id, addValid) => {
  const fieldId = id + "_validation_error"
  const elem = document.getElementById(fieldId)

  if (!elem) {
    return
  }

  elem.parentNode.removeChild(elem)


  document.getElementById(id).classList.remove("validation_error")

  if (addValid) {
    document.getElementById(id).classList.add("valid")
  }
}
